module.exports = __webpack_public_path__ + "img/mushroom.be5030ca.webp";